import http from './http'
import { handleHttpError } from './httpHelpers'

export function initCartService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_inizializzaCarrello",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/carrello/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function getCartService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_ottieniCarrello",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/carrello/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function closeCartService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_chiudiCarrello",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/carrello/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function addProductToCartService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_aggiungiProdotto",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/carrello/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function removeProductFromCartService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_rimuoviProdotto",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/carrello/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function addCartDiscountService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_aggiungiSconto",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/carrello/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function removeCartDiscountService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_rimuoviSconto",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/carrello/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}